export const RequiredTag = () => {
  return (
    <span className="bg-notification text-white rounded text-sm p-4 whitespace-nowrap">
      必須
    </span>
  );
};
